export default __webpack_public_path__ + "static/media/conveniencemobile-1.a14d1546.jpg";